export default "__VITE_ASSET__5dea3433__"